import { Checkbox } from 'antd';
import { IconSvg } from 'shared/icon';
import { HTMLAttributes, MouseEvent, ReactNode } from 'react';
import {
  StyledDraggableOption, StyledDraggableOptionContent, StyledDraggableOptionDrag, StyledDraggableOptionLabel,
} from 'components/styledComponents/select/Select.styled';

interface OptionData {
  disabled?: boolean;
  className?: string;
  displayName?:ReactNode| string;
  name: string;
}

export interface OptionProps {
  id: string | number;
  isSelected?: boolean;
  onClick: (id: string | number, e: MouseEvent) => void;
  data: OptionData;
  optionProps?: HTMLAttributes<HTMLDivElement>;
  dragProps?: HTMLAttributes<HTMLDivElement>;
  isDraggable?: boolean;
  isFixed?: boolean;
}

const Option = ({
  id, isSelected = false, onClick, data, optionProps, dragProps, isDraggable = true, isFixed = false,
}:OptionProps) => (
  <StyledDraggableOption
    {...optionProps}
    $isFixed={isFixed}
    onClick={(e: MouseEvent) => {
      if (!data.disabled) {
        onClick(id, e);
      }
    }}
  >
    <StyledDraggableOptionDrag {...dragProps} onClick={(e) => e.stopPropagation()} $isDraggable={isDraggable}>
      <IconSvg icon="DragIcon" width="1.28rem" height="1.28rem" color="" />
    </StyledDraggableOptionDrag>
    <StyledDraggableOptionContent>
      <Checkbox checked={isSelected} disabled={data.disabled} className={data.className}>
        <StyledDraggableOptionLabel $disabled={data.disabled} $isSelected={isSelected}>
          {data.displayName || data.name}
        </StyledDraggableOptionLabel>
      </Checkbox>
    </StyledDraggableOptionContent>
  </StyledDraggableOption>
);

export default Option;
